module.exports = __webpack_public_path__ + "img/CSA.a7b7f88c.svg";